module.exports = __webpack_public_path__ + "img/bmwtg@3x.c1a30729.png";